'use client';

import axios, { endpoints } from 'src/lib/axios';

import { setSession } from './utils';

// ----------------------------------------------------------------------

export type SignInParams = {
  email: string;
  password: string;
};

export type SignUpParams = {
  email: string;
  password: string;
  name: string;
  account_type: 'personal' | 'company';
  company_name?: string;
};

/** **************************************
 * Sign in
 *************************************** */
export const signInWithPassword = async ({ email, password }: SignInParams): Promise<void> => {
  try {
    const res = await axios.post(endpoints.auth.signIn, { email, password });

    // Backend returns { access_token, token_type, expires_in, user }
    const accessToken = res.data?.access_token;

    if (!accessToken) {
      throw new Error('Access token not found in response');
    }

    setSession(accessToken);
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};

/** **************************************
 * Sign up
 * Note: Backend does NOT return a token on register.
 * User must verify email before login.
 *************************************** */
export const signUp = async (params: SignUpParams): Promise<void> => {
  try {
    await axios.post(endpoints.auth.signUp, params);
    // Register returns { user_id, message } — no token until email verified
  } catch (error) {
    console.error('Error during sign up:', error);
    throw error;
  }
};

/** **************************************
 * Sign out
 *************************************** */
export const signOut = async (): Promise<void> => {
  try {
    await axios.post(endpoints.auth.logout).catch(() => null); // best-effort
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error);
    throw error;
  }
};
